<template>
  <CDropdown>
    <CDropdownToggle placement="bottom-end" class="py-0" :caret="false">
      <CAvatar color="warning" text-color="white" size="lg">
        {{ userInitials }}
      </CAvatar>
    </CDropdownToggle>
    <CDropdownMenu class="pt-0">
      <CDropdownHeader component="h6" class="bg-light fw-semibold py-2">
        Account
      </CDropdownHeader>

      <div v-if="errorMessage" class="px-2 pt-2">
        <ErrorBanner :message="errorMessage" @close="errorMessage = null" />
      </div>

      <!-- <CDropdownItem>
        <CIcon icon="cil-envelope-open" /> Messages
        <CBadge color="success" class="ms-auto">{{ itemsCount }}</CBadge>
      </CDropdownItem> -->

      <router-link
        to="/account/settings"
        style="text-decoration: none; color: inherit"
      >
        <CDropdownItem>
          <CIcon icon="cil-settings" />
          Settings
        </CDropdownItem>
      </router-link>

      <CDropdownDivider />
      <router-link
        to="/access/login"
        style="text-decoration: none; color: inherit"
      >
        <CDropdownItem @click="handleLogout">
          <CIcon icon="cil-lock-locked" /> Logout
        </CDropdownItem>
      </router-link>
    </CDropdownMenu>
  </CDropdown>
</template>

<script>
import avatar from '@/assets/images/avatars/8.jpg'
import { useRouter } from 'vue-router'
import { useStore } from 'vuex'
import { computed, ref } from 'vue'
import ErrorBanner from '@/components/ErrorBanner.vue'

export default {
  name: 'AppHeaderDropdownAccnt',
  components: {
    ErrorBanner,
  },
  setup() {
    const router = useRouter()
    const store = useStore()
    const errorMessage = ref(null)

    const userInitials = computed(() => {
      const user = store.getters.user
      if (user && user.first_name && user.last_name) {
        return user.first_name[0] + user.last_name[0]
      }
      return ''
    })

    const handleLogout = async () => {
      errorMessage.value = null
      try {
        await store.dispatch('logout')
        router.push({ name: 'Login' })
      } catch (error) {
        errorMessage.value = 'Logout failed. Please try again.'
      }
    }
    return {
      avatar: avatar,
      itemsCount: 42,
      handleLogout,
      userInitials,
      errorMessage,
    }
  },
}
</script>
